var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'room-default',
    _vm.isUniFrameWork && 'room-default-uni',
    _vm.props.message.flow === 'in' ? 'room-default-in' : 'room-default-out' ]},[_vm._v(" "+_vm._s(_vm.TUITranslateService.t("message.custom.自定义消息"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }